module.exports = __webpack_public_path__ + "4dfb49bab7865c8d8cfd19010ea2825e.png";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/saaspass-connect/manage/images/buttons/xxhdpi/login_with-saaspass.png
// module id = 1719
// module chunks = 0